var exports = {
  "w": "xe564cbfb--bccd5c--fake_header",
};

module.exports = exports;
